// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Account\PortcallAccountBindingModels.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { SendUserInviteRequestInvitedUser as _SendUserInviteRequestInvitedUser, SendUserInviteRequestInvitedUserData as _SendUserInviteRequestInvitedUserData, SendUserInviteRequestInvitedUserOptions as _SendUserInviteRequestInvitedUserOptions } from 'data/models/Accounts';

// ForgotPasswordRequestData is the class that ForgotPasswordRequest serializes to/from
export interface ForgotPasswordRequestData {
	
	
    Email : string;
}

// ForgotPasswordRequestOptions is the class which may be passed to the ForgotPasswordRequest constructor to define optional initial data values
export interface ForgotPasswordRequestOptions {
	
	
    Email? : string;
}

export class ForgotPasswordRequest {
	
	
    public Email : DataSignal<string>;

    constructor();
    constructor(data : ForgotPasswordRequestOptions);
    constructor(data: ForgotPasswordRequestOptions | null = null) {
	    
	    
        this.Email = jsonableObservable(S.value<string>(data && data.Email !== undefined ? data.Email : ''));
    }

    static key(obj : ForgotPasswordRequest) {
        return ;
    }
    
    static dataKey(obj : ForgotPasswordRequestOptions) {
        return ;
    }

    static update(obj : ForgotPasswordRequest, data : ForgotPasswordRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.Email !== undefined) obj.Email(data.Email);
        });
    }
}

// SendPasswordResetRequestData is the class that SendPasswordResetRequest serializes to/from
export interface SendPasswordResetRequestData {
	
    UserId : number;
	
}

// SendPasswordResetRequestOptions is the class which may be passed to the SendPasswordResetRequest constructor to define optional initial data values
export interface SendPasswordResetRequestOptions {
	
    UserId? : number;
	
}

export class SendPasswordResetRequest {
	
    public UserId : DataSignal<number>;
	

    constructor();
    constructor(data : SendPasswordResetRequestOptions);
    constructor(data: SendPasswordResetRequestOptions | null = null) {
	    
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
    }

    static key(obj : SendPasswordResetRequest) {
        return ;
    }
    
    static dataKey(obj : SendPasswordResetRequestOptions) {
        return ;
    }

    static update(obj : SendPasswordResetRequest, data : SendPasswordResetRequestOptions) {
        S.freeze(() => {
	        
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
        });
    }
}

// ResetPasswordRequestData is the class that ResetPasswordRequest serializes to/from
export interface ResetPasswordRequestData {
	
    UserId : number;
	
    ConfirmPassword : string | null;
    NewPassword : string;
    Token : string;
}

// ResetPasswordRequestOptions is the class which may be passed to the ResetPasswordRequest constructor to define optional initial data values
export interface ResetPasswordRequestOptions {
	
    UserId? : number;
	
    ConfirmPassword? : string | null;
    NewPassword? : string;
    Token? : string;
}

export class ResetPasswordRequest {
	
    public UserId : DataSignal<number>;
	
    public ConfirmPassword : DataSignal<string | null>;
    public NewPassword : DataSignal<string>;
    public Token : DataSignal<string>;

    constructor();
    constructor(data : ResetPasswordRequestOptions);
    constructor(data: ResetPasswordRequestOptions | null = null) {
	    
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.ConfirmPassword = jsonableObservable(S.value<string | null>(data && data.ConfirmPassword !== undefined ? data.ConfirmPassword : null));
        this.NewPassword = jsonableObservable(S.value<string>(data && data.NewPassword !== undefined ? data.NewPassword : ''));
        this.Token = jsonableObservable(S.value<string>(data && data.Token !== undefined ? data.Token : ''));
    }

    static key(obj : ResetPasswordRequest) {
        return ;
    }
    
    static dataKey(obj : ResetPasswordRequestOptions) {
        return ;
    }

    static update(obj : ResetPasswordRequest, data : ResetPasswordRequestOptions) {
        S.freeze(() => {
	        
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
            if (data.ConfirmPassword !== undefined) obj.ConfirmPassword(data.ConfirmPassword);
            if (data.NewPassword !== undefined) obj.NewPassword(data.NewPassword);
            if (data.Token !== undefined) obj.Token(data.Token);
        });
    }
}

// SendUserInviteRequestData is the class that SendUserInviteRequest serializes to/from
export interface SendUserInviteRequestData {
	
    InvitedUsers : _SendUserInviteRequestInvitedUserData[] | null;
    OrganizationId : number | null;
	
    IsNewOrganization : boolean;
    OrganizationName : string | null;
}

// SendUserInviteRequestOptions is the class which may be passed to the SendUserInviteRequest constructor to define optional initial data values
export interface SendUserInviteRequestOptions {
	
    InvitedUsers? : _SendUserInviteRequestInvitedUserOptions[] | null;
    OrganizationId? : number | null;
	
    IsNewOrganization? : boolean;
    OrganizationName? : string | null;
}

export class SendUserInviteRequest {
	
    public InvitedUsers : SDataArray<_SendUserInviteRequestInvitedUser>;
    public OrganizationId : DataSignal<number | null>;
	
    public IsNewOrganization : DataSignal<boolean>;
    public OrganizationName : DataSignal<string | null>;

    constructor();
    constructor(data : SendUserInviteRequestOptions);
    constructor(data: SendUserInviteRequestOptions | null = null) {
	    
        this.InvitedUsers = SArray<_SendUserInviteRequestInvitedUser>([]);
        this.OrganizationId = jsonableObservable(S.value<number | null>(data && data.OrganizationId !== undefined ? data.OrganizationId : null));
	    
        this.IsNewOrganization = jsonableObservable(S.value<boolean>(data && data.IsNewOrganization !== undefined ? data.IsNewOrganization : false));
        this.OrganizationName = jsonableObservable(S.value<string | null>(data && data.OrganizationName !== undefined ? data.OrganizationName : null));
    }

    static key(obj : SendUserInviteRequest) {
        return ;
    }
    
    static dataKey(obj : SendUserInviteRequestOptions) {
        return ;
    }

    static update(obj : SendUserInviteRequest, data : SendUserInviteRequestOptions) {
        S.freeze(() => {
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.IsNewOrganization !== undefined) obj.IsNewOrganization(data.IsNewOrganization);
            if (data.OrganizationName !== undefined) obj.OrganizationName(data.OrganizationName);
        });
    }
}

// SendUserInviteRequestInvitedUserData is the class that SendUserInviteRequestInvitedUser serializes to/from
export interface SendUserInviteRequestInvitedUserData {
	
	
    Email : string;
    Roles : number[];
}

// SendUserInviteRequestInvitedUserOptions is the class which may be passed to the SendUserInviteRequestInvitedUser constructor to define optional initial data values
export interface SendUserInviteRequestInvitedUserOptions {
	
	
    Email? : string;
    Roles? : number[];
}

export class SendUserInviteRequestInvitedUser {
	
	
    public Email : DataSignal<string>;
    public Roles : SDataArray<number>;

    constructor();
    constructor(data : SendUserInviteRequestInvitedUserOptions);
    constructor(data: SendUserInviteRequestInvitedUserOptions | null = null) {
	    
	    
        this.Email = jsonableObservable(S.value<string>(data && data.Email !== undefined ? data.Email : ''));
        this.Roles = jsonableObservable(SArray<number>(data && data.Roles !== undefined ? data.Roles : []));
    }

    static key(obj : SendUserInviteRequestInvitedUser) {
        return ;
    }
    
    static dataKey(obj : SendUserInviteRequestInvitedUserOptions) {
        return ;
    }

    static update(obj : SendUserInviteRequestInvitedUser, data : SendUserInviteRequestInvitedUserOptions) {
        S.freeze(() => {
	        
	        
            if (data.Email !== undefined) obj.Email(data.Email);
            if (data.Roles !== undefined) obj.Roles(data.Roles);
        });
    }
}

// AcceptInvitationRequestData is the class that AcceptInvitationRequest serializes to/from
export interface AcceptInvitationRequestData {
	
    InvitationId : number;
	
    ConfirmPassword : string | null;
    FirstName : string;
    LastName : string;
    Password : string;
    Token : string;
}

// AcceptInvitationRequestOptions is the class which may be passed to the AcceptInvitationRequest constructor to define optional initial data values
export interface AcceptInvitationRequestOptions {
	
    InvitationId? : number;
	
    ConfirmPassword? : string | null;
    FirstName? : string;
    LastName? : string;
    Password? : string;
    Token? : string;
}

export class AcceptInvitationRequest {
	
    public InvitationId : DataSignal<number>;
	
    public ConfirmPassword : DataSignal<string | null>;
    public FirstName : DataSignal<string>;
    public LastName : DataSignal<string>;
    public Password : DataSignal<string>;
    public Token : DataSignal<string>;

    constructor();
    constructor(data : AcceptInvitationRequestOptions);
    constructor(data: AcceptInvitationRequestOptions | null = null) {
	    
        this.InvitationId = jsonableObservable(S.value<number>(data && data.InvitationId !== undefined ? data.InvitationId : 0));
	    
        this.ConfirmPassword = jsonableObservable(S.value<string | null>(data && data.ConfirmPassword !== undefined ? data.ConfirmPassword : null));
        this.FirstName = jsonableObservable(S.value<string>(data && data.FirstName !== undefined ? data.FirstName : ''));
        this.LastName = jsonableObservable(S.value<string>(data && data.LastName !== undefined ? data.LastName : ''));
        this.Password = jsonableObservable(S.value<string>(data && data.Password !== undefined ? data.Password : ''));
        this.Token = jsonableObservable(S.value<string>(data && data.Token !== undefined ? data.Token : ''));
    }

    static key(obj : AcceptInvitationRequest) {
        return ;
    }
    
    static dataKey(obj : AcceptInvitationRequestOptions) {
        return ;
    }

    static update(obj : AcceptInvitationRequest, data : AcceptInvitationRequestOptions) {
        S.freeze(() => {
	        
            if (data.InvitationId !== undefined) obj.InvitationId(data.InvitationId);
	        
            if (data.ConfirmPassword !== undefined) obj.ConfirmPassword(data.ConfirmPassword);
            if (data.FirstName !== undefined) obj.FirstName(data.FirstName);
            if (data.LastName !== undefined) obj.LastName(data.LastName);
            if (data.Password !== undefined) obj.Password(data.Password);
            if (data.Token !== undefined) obj.Token(data.Token);
        });
    }
}

// CheckInvitationRequestData is the class that CheckInvitationRequest serializes to/from
export interface CheckInvitationRequestData {
	
    InvitationId : number;
	
    Token : string;
}

// CheckInvitationRequestOptions is the class which may be passed to the CheckInvitationRequest constructor to define optional initial data values
export interface CheckInvitationRequestOptions {
	
    InvitationId? : number;
	
    Token? : string;
}

export class CheckInvitationRequest {
	
    public InvitationId : DataSignal<number>;
	
    public Token : DataSignal<string>;

    constructor();
    constructor(data : CheckInvitationRequestOptions);
    constructor(data: CheckInvitationRequestOptions | null = null) {
	    
        this.InvitationId = jsonableObservable(S.value<number>(data && data.InvitationId !== undefined ? data.InvitationId : 0));
	    
        this.Token = jsonableObservable(S.value<string>(data && data.Token !== undefined ? data.Token : ''));
    }

    static key(obj : CheckInvitationRequest) {
        return ;
    }
    
    static dataKey(obj : CheckInvitationRequestOptions) {
        return ;
    }

    static update(obj : CheckInvitationRequest, data : CheckInvitationRequestOptions) {
        S.freeze(() => {
	        
            if (data.InvitationId !== undefined) obj.InvitationId(data.InvitationId);
	        
            if (data.Token !== undefined) obj.Token(data.Token);
        });
    }
}

// RestoreAccountRequestData is the class that RestoreAccountRequest serializes to/from
export interface RestoreAccountRequestData {
	
    InvitationId : number;
	
    Token : string;
}

// RestoreAccountRequestOptions is the class which may be passed to the RestoreAccountRequest constructor to define optional initial data values
export interface RestoreAccountRequestOptions {
	
    InvitationId? : number;
	
    Token? : string;
}

export class RestoreAccountRequest {
	
    public InvitationId : DataSignal<number>;
	
    public Token : DataSignal<string>;

    constructor();
    constructor(data : RestoreAccountRequestOptions);
    constructor(data: RestoreAccountRequestOptions | null = null) {
	    
        this.InvitationId = jsonableObservable(S.value<number>(data && data.InvitationId !== undefined ? data.InvitationId : 0));
	    
        this.Token = jsonableObservable(S.value<string>(data && data.Token !== undefined ? data.Token : ''));
    }

    static key(obj : RestoreAccountRequest) {
        return ;
    }
    
    static dataKey(obj : RestoreAccountRequestOptions) {
        return ;
    }

    static update(obj : RestoreAccountRequest, data : RestoreAccountRequestOptions) {
        S.freeze(() => {
	        
            if (data.InvitationId !== undefined) obj.InvitationId(data.InvitationId);
	        
            if (data.Token !== undefined) obj.Token(data.Token);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Accounts.ts